/**
 * collection-scroll-return.js
 * Restores scroll position to the originating product card after the shopper
 * returns from a PDP, lazily re-loading paginated (show-more) content until the
 * card is in the DOM, then anchoring to it.
 *
 * Anchoring (fixes both the "sube y baja" jitter and the "no vuelve al
 * producto" miss):
 *   We can't trust img.complete/load events — lazy images have no src yet, so
 *   they report complete and never fire load until lazyload swaps them in.
 *   Instead we treat a CHANGING document height as "reflow still happening" and
 *   stay glued to the card until the height is quiet for `quietMs` (but never
 *   bail before `minMs`, so we don't quit before lazyload even runs), capped at
 *   `maxMs`. We bail out immediately if the user scrolls, so we never fight them.
 *
 * Pagination (fixes autoscroll dying after back navigation):
 *   loadNext() keeps the page-load-bound show-more <a> and only updates its
 *   href instead of replaceWith(), so the click handler bound by
 *   initShowMoreEvent() survives and autoscroll resumes normally.
 */

if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

$(document).on('click', '.tt-product-listing a[href*="/products/"]', function () {
  var handle = $(this).attr('href').split('/products/')[1].split(/[?#]/)[0];
  sessionStorage.setItem('shop_return', JSON.stringify({
    url: location.pathname + location.search,
    handle: handle
  }));
});

$(window).on('pageshow', function () {
  var raw = sessionStorage.getItem('shop_return');
  if (!raw) return;
  var data = JSON.parse(raw);
  if (data.url !== location.pathname + location.search) return;
  sessionStorage.removeItem('shop_return');

  function findCard() {
    return document.querySelector('.tt-product-listing a[href*="/products/' + data.handle + '"]');
  }

  function productHandleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    return link.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
  }

  function productAlreadyLoaded(handle) {
    if (!handle) return false;
    return !!document.querySelector('.tt-product-listing a[href*="/products/' + handle + '"]');
  }

  // Absolute scroll offset that puts the card just below the sticky header.
  function targetTop() {
    var el = findCard();
    if (!el) return null;
    var stuck = $('.stuck').length ? $('.stuck').height() : 0;
    return el.getBoundingClientRect().top + window.pageYOffset - stuck - 20;
  }

  function docHeight() {
    var b = document.body, d = document.documentElement;
    return Math.max(b.scrollHeight, b.offsetHeight, d.scrollHeight, d.offsetHeight);
  }

  function settle() {
    $('.custom-loader').hide();

    var aborted = false;
    var minMs = 600;     // never let go before this (lazyload needs time to run)
    var quietMs = 350;   // let go once height has been still this long
    var maxMs = 4000;    // hard ceiling

    function cleanup() {
      window.removeEventListener('wheel', onUserScroll);
      window.removeEventListener('touchstart', onUserScroll);
      window.removeEventListener('keydown', onKey);
    }
    function onUserScroll() { aborted = true; cleanup(); }
    function onKey(e) {
      // space, page up/down, end, home, arrow up/down = intent to scroll
      if ([32, 33, 34, 35, 36, 38, 40].indexOf(e.keyCode) !== -1) onUserScroll();
    }

    window.addEventListener('wheel', onUserScroll, { passive: true });
    window.addEventListener('touchstart', onUserScroll, { passive: true });
    window.addEventListener('keydown', onKey);

    function anchor() {
      if (aborted) return;
      var top = targetTop();
      if (top == null) return;
      if (Math.abs(window.pageYOffset - top) > 1) window.scrollTo(0, top);
    }

    // Stay glued to the card while the layout is still reflowing. A changing
    // document height is our reflow signal (covers lazyload swapping images,
    // late-loading rows, etc.).
    var start = Date.now();
    var lastHeight = docHeight();
    var lastChange = start;

    (function frame() {
      if (aborted) return;

      anchor();

      var h = docHeight();
      if (h !== lastHeight) { lastHeight = h; lastChange = Date.now(); }

      var now = Date.now();
      var elapsed = now - start;
      var quietFor = now - lastChange;

      if ((elapsed > minMs && quietFor > quietMs) || elapsed > maxMs) {
        anchor();        // final correction once everything has settled
        cleanup();
        return;
      }
      requestAnimationFrame(frame);
    })();
  }

  if (findCard()) { settle(); return; }

  $('.custom-loader').show();
  var guard = 0;
  (function loadNext() {
    var $btn = $('.show-more a').last();
    var href = $btn.attr('href');
    if (!href || $btn.hasClass('disable') || guard++ > 40) { settle(); return; }
    $btn.addClass('disable');

    $.ajax({
      type: 'GET', url: href, dataType: 'html',
      success: function (html) {
        var $html = $(html);
        $html.find('.tt-product-listing > div').each(function () {
          var handle = productHandleFromCard(this);
          if (!handle || !productAlreadyLoaded(handle)) {
            $('.tt-product-listing').append($(this));
          }
        });

        // Keep the page-load-bound show-more button: update its href instead of
        // replaceWith, which would strip the click handler and kill autoscroll.
        var nextHref = $html.find('.show-more a').attr('href');
        if (nextHref) {
          $('.show-more a').attr('href', nextHref).removeClass('disable');
        } else {
          $('.show-more a').remove();
        }

        if (findCard()) {
          $('body').trigger('refreshCurrency');
          if (typeof ttProductSmall === 'function') ttProductSmall();
          if (typeof lazyload === 'function') lazyload();
          settle();
        } else {
          loadNext();
        }
      },
      error: settle
    });
  })();
});
